<template>
	<div class="">
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-title class="ptxxx-0">
			<v-form @submit.prevent="search" class="form-inline">
				<v-row class="">
					<v-col cols="12" class="d-flex flex-wrap align-center">
						<v-text-field
							outlined
							class="search-field-name mr-2"
							dense
							v-model="query.name"
							label="名称"
							hide-details
						/>
						<v-text-field
							outlined
							class="search-field-short mr-2"
							dense
							v-model="query.code"
							label="编码"
							hide-details
						/>
						<v-select
							outlined
							class="mr-2"
							dense
							label="状态"
							v-model="query.status"
							:items="refs['SupplierStatus']"
							hide-details
							clearable
						></v-select>
						<v-select
							outlined
							class="mr-2"
							dense
							label="类型"
							v-model="query.type"
							:items="refs['SupplierType']"
							hide-details
							clearable
						></v-select>
						<v-btn color="primary" size="large" class="mr-2" @click="search">查询</v-btn>
						<v-icon class="mr-2" v-if="queryPairs.length" @click="reset">$close</v-icon>
					</v-col>
				</v-row>
			</v-form>
		</v-card-title>

		<v-data-table-server
			:headers="headers"
			:items="objects"
			@update:options="load"
			:items-length="parseInt(total)"
			:loading="loading"
			:show-select="showSelect"
			:single-select="singleSelect"
			v-model="selected"
			multi-sort
		>
			<template v-slot:top>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>

			<template #item.status="{ item }">
				<enum-chip kind="status" :value="item.status" />
			</template>
			<template #item.type="{ item }">
				<enum-chip kind="supplierType" :value="item.type" />
			</template>
			<template #item.name="{ item }">
				{{ item.code }} {{ item.name }}
			</template>
			<template #item.certificates="{ item }">
				<div v-if="certList(item).length" class="d-inline-flex align-center flex-nowrap py-1">
					<v-img
						v-for="url in certThumbs(item)"
						:key="url"
						:src="url"
						cover
						width="48"
						height="48"
						class="mr-1 rounded cert-thumb"
						title="点击放大"
						@click.stop="previewUrl = url"
					/>
					<span
						v-if="certList(item).length > 3"
						class="text-caption text-medium-emphasis cert-more"
						title="查看全部证照"
						@click.stop="openCerts(item)"
					>
						+{{ certList(item).length - 3 }}
					</span>
				</div>
				<span v-else class="text-medium-emphasis">—</span>
			</template>
			<template #item.contact="{ item }">
				{{ item.contact }}
			</template>
			<template #item.website="{ item }">
				<a v-if="item.website" :href="item.website" target="_blank" rel="noopener noreferrer">{{
					item.website
				}}</a>
			</template>

			<template v-slot:item.action="{ item }">
				<slot name="actions" v-bind="{ item }"></slot>
			</template>

			<template v-slot:footer>
				<slot name="batchActions" v-bind="{ selected }"></slot>
			</template>
		</v-data-table-server>

		<v-dialog v-model="certDlg" max-width="720">
			<v-card>
				<v-card-title class="d-flex align-center">
					{{ certSupplier?.name }} 证照
					<v-spacer />
					<v-btn icon variant="text" @click="certDlg = false">
						<v-icon>$close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<div v-if="certList(certSupplier).length" class="d-flex flex-wrap">
						<v-img
							v-for="url in certList(certSupplier)"
							:key="url"
							:src="url"
							contain
							width="160"
							height="160"
							class="mr-2 mb-2 grey-lighten-2"
							style="cursor: zoom-in"
							@click="previewUrl = url"
						/>
					</div>
					<div v-else class="text-medium-emphasis">暂无证照图片</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="previewUrl" max-width="90%">
			<v-img
				v-if="previewUrl"
				:src="previewUrl"
				contain
				style="max-height: 85vh; cursor: zoom-out"
				@click="previewUrl = null"
			/>
		</v-dialog>
	</div>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'
import qs from 'qs'
import EnumChip from '../common/EnumChip.vue'

export default {
	components: { EnumChip },
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '名称', align: 'left', sortable: true, value: 'name' },
				{ title: '营业执照', sortable: false, value: 'certificates' },
				{ title: '类型', sortable: true, value: 'type' },
				{ title: '联系人', sortable: true, value: 'contact' },
				{ title: '电话', sortable: true, value: 'tel' },
				{ title: '地址', sortable: true, value: 'address' },
				{ title: '网址', sortable: false, value: 'website' },
				{ title: '状态', value: 'status' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		const qps = qs.parse(location.search, { ignoreQueryPrefix: true })
		return {
			query: qps,
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			options: null, //当前选项（保持）
			refs: {},
			selected: [],
			errors: {},
			certDlg: false,
			certSupplier: null,
			previewUrl: null
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
		this.$api.common.meta('Supplier', 'SupplierType,SupplierStatus', (res) => {
			this.refs = res
		})
		this.load()
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {},
	methods: {
		certList(item) {
			const list = item?.certificates
			return Array.isArray(list) ? list.filter(Boolean) : []
		},
		certThumbs(item) {
			return this.certList(item).slice(0, 3)
		},
		openCerts(item) {
			this.certSupplier = item
			this.previewUrl = null
			this.certDlg = true
		},
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
				this.load()
			}
		},
		reset() {
			this.query = {}
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) {
				this.options = options
			}

			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}

			this.currentQuery = clone(this.query)
			this.$api.supplier.search(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
.cert-thumb {
	cursor: zoom-in;
	flex-shrink: 0;
	background: #eee;
}
.cert-more {
	cursor: pointer;
	flex-shrink: 0;
}
</style>
